//This is for listing all CURRENT leagues

import React, { useEffect, useState } from 'react'
import './AdminLeagueList.css'
import AdminNavigation from './AdminNavigation'
import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import { NavLink } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminTournaments = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [tournamentId, setTournamentId] = useState('')
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [tournamentDeleted, setTournamentDeleted] = useState()
	const [tournamentToDelete, setTournamentToDelete] = useState()
	const [loadedTournaments, setLoadedTournaments] = useState()

	//Let's get a list of all Tournaments
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setTournamentDeleted(false)
			//setLeagueArchived(false)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/tournaments',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				//console.log(responseData)

				setLoadedTournaments(responseData.allTournaments)
				setIsLoading(false)
			} catch (err) {
				setError('ERROR: ' + err.message)
			}
			//setLeagueArchived(false)
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedTournaments, tournamentDeleted])

	const errorHandler = () => {
		setError(null)
	}

	//******************************************************** */
	//
	//     Delete warning
	//
	//******************************************************** */

	const showDeleteWarningHandler = (e, tournamentname) => {
		const value = e.target.id
		console.log('tournament to delete: ' + tournamentname)
		setTournamentToDelete(tournamentname)
		setTournamentId(loadedTournaments[value]._id)
		setShowConfirmModal(true)
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
	}

	//console.log('league right here: ' + leagueId)
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${tournamentId}/deleteTournament`,
				'DELETE',
			)
		} catch (err) {}
		setTournamentDeleted(true)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete <h1>{tournamentToDelete}</h1>
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE TOURNAMENT
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && loadedTournaments && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>Tournaments</h1>
					<table id='teams'>
						<thead>
							<tr>
								<th>Tournament Name</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedTournaments.map((tournament, key) => {
								return (
									<tr key={key}>
										<td>{tournament.tournamentName}</td>
										<td>
											{/* These buttons used to be NavLinks.  But I changed them to look better */}
											<NavLink
												className='navlinks'
												to={`/admin/updateTournament/${tournament._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
										<td>
											<button
												className='buttonButton'
												style={{ color: 'red' }}
												id={key}
												onClick={(e) =>
													showDeleteWarningHandler(e, tournament.tournamentName)
												}
											>
												DELETE
											</button>
										</td>
									</tr>
								)
							})}
							<tr style={{ backgroundColor: '#e0e0e0', display: 'block' }}>
								<td>
									<AdminButton
										to={`/admin/tournaments/new`}
										exact
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
									>
										Add new Tournament
									</AdminButton>
								</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminTournaments
